/**
 * @description 文件相关工具函数
 */
import dayjs from "dayjs";

/**
 * @description 导出Excel
 * @param {String} url
 * @param {String} fileName
 */
export const exportExcel = (url, fileName) => {
	let a = document.createElement("a");
	const dateTime = dayjs().format("YYYYMMDDHHmmss");

	a.href = url;
	a.download = `${fileName}-${dateTime}.xlsx`;
	a.click();
};

/**
 * @description 导出Excel Blob文件
 * @param {*} result
 * @param {String} fileName
 */
export const exportBlobExcel = (result, fileName) => {
	const blob = new Blob([result], {
		// 二进制流，这里的文件类型是xlsx
		type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
	});

	const a = document.createElement("a");
	const url = window.URL.createObjectURL(blob);
	const dateTime = dayjs().format("YYYYMMDDHHmmss");

	a.href = url;
	a.download = `.${fileName}-${dateTime}`;
	document.body.appendChild(a);
	a.click();
	window.URL.revokeObjectURL(a.href);
	document.body.removeChild(a);
};

/**
 * @description 下载文件
 * @param {String} url
 * @param {String} fileName
 */
export const downloadFile = (url, fileName) => {
	const req = new XMLHttpRequest();

	req.open("GET", url, true);
	req.responseType = "blob";

	req.onload = function () {
		if (this.status === 200) {
			const blob = this.response;
			const a = document.createElement("a");

			a.href = window.URL.createObjectURL(blob);
			a.download = fileName;
			document.body.appendChild(a);
			a.click();
			window.URL.revokeObjectURL(a.href);
			document.body.removeChild(a);
		}
	};

	req.send();
};

/**
 * @description 判断文件是否为图片
 * @param {string} url
 * @returns
 */
export const isImage = (url) => {
	return url.match(/\.(jpeg|jpg|gif|png|bmp|svg|webp|ico|tif|tiff)$/i) !== null;
};

/**
 * @description 判断文件url是否包含http
 * @param {string} url
 * @returns
 */
export const hasHttp = (url) => {
	return url.match(/^http/i) !== null;
};

/**
 * @description 获取文件后缀
 * @param {string} fileName
 * @returns
 */
export const getFileSuffix = (fileName) => {
	const index = fileName.lastIndexOf(".");

	return fileName.slice(Math.max(0, index + 1));
};
